import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';

@Component({
  standalone: false,
  selector: 'app-cell-reseller',
  template: `
    {{ renderValue | date: 'dd-MM-yyyy HH:mm:ss' }}
  `
})
export class CellDateComponent implements OnInit, ViewCell {
  @Input() value: string | number;
  @Input() rowData: any;

  public renderValue: Date;

  private parseCompactDate(value: string | number): Date | null {
    if (value === null || value === undefined) {
      return null;
    }
    if (typeof value === 'number') {
      const numeric = new Date(value);
      return Number.isNaN(numeric.getTime()) ? null : numeric;
    }
    if (typeof value !== 'string') {
      return null;
    }

    const match = value.match(
      /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})?(Z|[+-]\d{2}:?\d{2})?$/
    );
    if (match) {
      const [, y, m, d, hh, mm, ssRaw, tzRaw] = match;
      const ss = ssRaw || '00';
      let tz = tzRaw || 'Z';
      if (tz !== 'Z' && tz.length === 5) {
        tz = `${tz.slice(0, 3)}:${tz.slice(3)}`;
      }
      const iso = `${y}-${m}-${d}T${hh}:${mm}:${ss}${tz}`;
      const parsed = new Date(iso);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
    }

    const fallback = new Date(value);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  }

  ngOnInit() {
    if (!!this.value) {
      const parsed = this.parseCompactDate(this.value);
      if (parsed) {
        this.renderValue = parsed;
      }
    }
  }
}
